// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoIcon{width:16px;height:16px;margin-left:5px}`, "",{"version":3,"sources":["webpack://./src/Widgets/HelpInfo/HelpInfo.scss"],"names":[],"mappings":"AAAA,UACI,UAAA,CACA,WAAA,CACA,eAAA","sourcesContent":[".infoIcon {\n    width: 16px;\n    height: 16px;\n    margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
